import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c16bb30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "relative flex h-[46px] w-[46px] items-center" }
const _hoisted_2 = {
  role: "presentation",
  "aria-hidden": "true",
  class: "text-over-icon"
}

import { ComputedRef, PropType, Ref, computed, ref } from 'vue';
import { BlackDesertItem, BlackDesertItemTooltip, BlackDesertItemType } from '@blackdesertmarket/interfaces';
import { isValidBlackDesertItemType } from '@blackdesertmarket/objects';
import { VueAttributeClass } from '@/types/attributes-vue';
import { HttpMethod } from '@/enums/http';
import { usePreferencesStore } from '@/stores/preferences';
import { UseItemTypeFetchReturn, useItemTypeFetch } from '@/composables/item-type/use-item-type-fetch';
import { useMarketApi } from '@/composables/use-market-api';
import AppIcon from '@/components/Base/AppIcon.vue';
import AppLoader from '@/components/Base/AppLoader/AppLoader.vue';
import AppTooltip from '@/components/Base/AppTooltip.vue';
import ListItemTooltip from '@/components/ListItem/ListItemTooltip/ListItemTooltip.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListItemIcon',
  props: {
  src: {
    type: String,
    required: true,
  },
  item: {
    type: Object as PropType<BlackDesertItem>,
  },
  text: {
    type: String,
  },
  class: {
    type: [String, Object] as PropType<VueAttributeClass>,
  },
},
  setup(__props) {

const props = __props;



const preferencesStore = usePreferencesStore();

const sent: Ref<boolean> = ref(false);
const loaded: Ref<boolean> = ref(false);

const itemType: Ref<BlackDesertItemType | null> = ref(null);
const itemTooltip: Ref<BlackDesertItemTooltip | null> = ref(null);

const itemGradeClass: ComputedRef<string> = computed((): string => {
  if (!loaded.value || !itemType.value || !itemType.value.grade) {
    return 'tooltip:item-default';
  }

  return `tooltip:item-grade-${itemType.value.grade}`;
});

/**
 * TODO: Call this function only when user has hovered on ListItemIcon for some time
 */
const handleTooltipShow = async (): Promise<void> => {
  if (!props.item || sent.value) {
    return;
  }

  sent.value = true;

  if (!isValidBlackDesertItemType(props.item)) {
    const itemTypeFetch: UseItemTypeFetchReturn = useItemTypeFetch(props.item.id);
    itemType.value = await itemTypeFetch.fetchBaseType();
  } else {
    itemType.value = props.item as BlackDesertItemType;
  }

  if (!itemType.value) {
    return;
  }

  const marketApi = useMarketApi<BlackDesertItemTooltip>(
    HttpMethod.GET,
    `/item/${itemType.value.id}/${itemType.value.enhancement}/tooltip`,
    {
      language: preferencesStore.getLanguage,
    },
  );

  const response = await marketApi.execute();

  if (response.data.value) {
    itemTooltip.value = response.data.value.data;
    loaded.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppTooltip, {
    placement: "right-start",
    disabled: !props.item,
    class: _normalizeClass(_unref(itemGradeClass)),
    "show-on-click": "",
    onShow: handleTooltipShow
  }, {
    popper: _withCtx(() => [
      (itemType.value && itemTooltip.value)
        ? (_openBlock(), _createBlock(ListItemTooltip, {
            key: 0,
            "item-type": itemType.value,
            "item-tooltip": itemTooltip.value
          }, null, 8, ["item-type", "item-tooltip"]))
        : (_openBlock(), _createBlock(AppLoader, { key: 1 }))
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(AppIcon, {
          src: props.src,
          class: _normalizeClass([props.class, "icon border-dark-600"])
        }, null, 8, ["src", "class"]),
        _createElementVNode("span", _hoisted_2, _toDisplayString(__props.text), 1)
      ])
    ]),
    _: 1
  }, 8, ["disabled", "class"]))
}
}

})